import React from 'react';
import {
  Box,
  MetaInfo,
  Content,
  ReplyHeader,
  ReplyFooter,
  AttachmentIcon,
  CloseButton,
  ScrollButton,
  BoxButtons
} from './styled';
import { GrAttachment } from 'react-icons/gr';
import { IoArrowUpSharp, IoClose } from 'react-icons/io5';
import { useSmartScroll } from 'hooks/useSmartScroll';

export function RepliedCommentContainer({ comment, onClose }) {
  const {
    id,
    description,
    creation_date: createdAt,
    user_id,
    attachments
  } = comment;

  const hasAttachments = attachments && attachments.length > 0;

  // Use custom scroll hook
  const scrollToElement = useSmartScroll({
    offset: 80,
    Highlight: true,
    highlightColor: '#A9B2C0'
  });

  const handleScroll = () => {
    scrollToElement(id);
  };

  const formattedDate = new Date(createdAt).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });

  return (
    <Box>
      <BoxButtons>
        <ReplyHeader>Em resposta a:</ReplyHeader>
        <div>
          <ScrollButton
            onClick={handleScroll}
            title="Ir para o comentário original"
          >
            <IoArrowUpSharp size={22} />
          </ScrollButton>

          <CloseButton onClick={onClose} title="Fechar resposta">
            <IoClose size={28} color="red" />
          </CloseButton>
        </div>
      </BoxButtons>
      <MetaInfo>
        <span>{user_id}</span>
        <span>{formattedDate}</span>
      </MetaInfo>

      <Content dangerouslySetInnerHTML={{ __html: description }} />

      <ReplyFooter>
        {hasAttachments && (
          <>
            <AttachmentIcon>
              <GrAttachment />
            </AttachmentIcon>
            <span>
              {attachments.length} anexo{attachments.length > 1 ? 's' : ''}
            </span>
          </>
        )}
      </ReplyFooter>
    </Box>
  );
}
